import React from "react";
import { DropdownWithList } from "./DropdownWithList";
import { ListInt } from './List';

export interface ListButtonProps {
  list: Array<ListInt>;
  setValue: Function;
  value: any;
  className: string;
  isValid: boolean;
  invalidFeedback: string;
  label: string;
  header: string;
};

export const DropdownWithHeader = ({ ...props }: ListButtonProps) => {
  function setValue(val: any, text: string) {
    props.setValue && props.setValue(val, text);
  }

  return (
    <div className="dropdown-menu-header-container">
      <p className="dropdown-menu-header font-weight-bold">{props.header}</p>
      <DropdownWithList
        className={props.className}
        list={props.list}
        label={props.label}
        value={props.value}
        setValue={(val, text) => setValue(val, text)}
        isValid={props.isValid}
        invalidFeedback={props.invalidFeedback}
      />
    </div>
  );
};
